import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

import { LAYER_SUBTYPES } from '../../../api/Layers/Layers';
import { getAccessToken } from '../../../api/Layers/layer-operations';

const LayerAccessTokenField = ({ layerSubType, layer }) => {
  if (layerSubType === LAYER_SUBTYPES.MAPBOXGL) {
    return (
      <Form.Group>
        <Form.Label>Access Token</Form.Label>
        <Form.Control
          name="accessToken"
          defaultValue={getAccessToken(layer)}
          placeholder="What's the access token for this layer?"
        />
        <Form.Text className="text-muted">
          If empty will default to <b>no-token</b>
        </Form.Text>
      </Form.Group>
    );
  }
  return '';
};
LayerAccessTokenField.propTypes = {
  layer: PropTypes.object.isRequired,
  layerSubType: PropTypes.string.isRequired
};

export default LayerAccessTokenField;
